import CallToAction from '../components/CallToAction'
import '../styles/landing.css'

export default function Hero() {
  return (
    <section id="hero">
      <div className="hero-container">

        {/* Titulo a todo lo ancho */}
        <h3 className="hero-title">
          Asegura tu ingreso a la universidad con Vortex Admisión, la guía completa para presentar tu EXANI-II 2027.
        </h3>

        {/* Fila: texto + logo */}
        <div style={{ textAlign: 'justify' }} className="hero-row">
          <p className="hero-text">
            El sistema integral de preparación de alto rendimiento para el examen EXANI-II del Ceneval,
            utilizado por universidades públicas, autónomas e instituciones de educación superior en México.
            Domina las áreas transversales (Comprensión Lectora, Redacción Indirecta, Pensamiento Matemático e Inglés)
            y tus módulos disciplinares específicos con simuladores cronometrados de 168 reactivos,
            Inteligencia Artificial y herramientas de estudio auditivo.
          </p>

          {/* Visual */}
          <div className="hero-visual">
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <img
                src="/icons/logo.png"
                alt="Vortex EXANI-II"
                className="hero-logo"
              />
              <div className="hero-float hero-float-top">
                <span style={{ fontSize: '2.2rem' }}>🎓</span>
              </div>
              <div className="hero-float hero-float-bot">
                <span style={{ fontSize: '2rem' }}>⚓</span>
              </div>
            </div>
          </div>
        </div>

        {/* Botones */}
        <CallToAction />

      </div>
    </section>
  )
}